import { Box, Typography } from "@mui/material";

export const RuleGraphCartShareBadge = ({
  percentage,
}: {
  percentage: number;
}) => (
  <Box
    data-testid="rule-graph-cart-share-badge"
    sx={(theme) => ({
      alignItems: "center",
      backgroundColor: theme.igPrimitives.gray[500],
      borderRadius: "4px",
      boxSizing: "border-box",
      display: "flex",
      flexShrink: 0,
      gap: 1,
      px: 2.5,
      py: 1,
      whiteSpace: "nowrap",
    })}
  >
    <Typography sx={{ fontSize: 12, fontWeight: 600, lineHeight: 1.5 }}>
      {percentage}%
    </Typography>
    <Typography
      sx={(theme) => ({
        color: theme.palette.text.tertiary,
        fontSize: 10,
        lineHeight: 1.5,
      })}
    >
      of carts
    </Typography>
  </Box>
);
